import { render } from "./Introduction.vue?vue&type=template&id=314d70f0&scoped=true"
import script from "./Introduction.vue?vue&type=script&lang=js"
export * from "./Introduction.vue?vue&type=script&lang=js"

import "./Introduction.vue?vue&type=style&index=0&id=314d70f0&lang=stylus&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-314d70f0"]])

export default __exports__